export const translations = {
  'fr-FR': {
    translation: {
      addUser: 'Ajouter un utilisateur',
      editUser: "Éditer l'utilisateur",
      firstName: 'Prénom',
      lastName: 'Nom',
      name: 'Nom',
      role: 'Rôle',
      status: 'État',
      email: 'E-mail',
      phone: 'téléphone',
      type: 'Taper',
      details: 'Détails',
      nodes: 'Nœuds',
      roles: 'Rôles',
      cancel: 'Annuler',
      submit: 'envoyer',
      delete: 'Supprimer',
      create: 'Créer',
      deleteNodeError: 'Erreur de suppression du nœud',
      deleteConfirmation: 'Voulez-vous vraiment supprimer',
      warning: 'Avertissement',
      Alert: 'Alerte',
      deleteSure: 'Oui, j’en suis sûr',
      nodesWillBeCreatedAt: 'Les nœuds seront créés à',
      searchFor: 'Rechercher',
      rolesError: 'Erreur lors de la récupération des rôles',
      userListError: "Erreur d'extraction de la liste des utilisateurs",
      organisationListError:
        'Erreur lors de la récupération de la liste des organisations',
      loadingRoles: 'Chargement des rôles...',
      selectRole: 'Sélectionner le rôle',
      validEmail: 'Saisissez une Adresse e-mail valide',
      requiredEmail: 'L’e-mail est requis',
      resend: 'Renvoyer',
      restrictedDomain: 'Restricted email domain',
      addUserSuccess: 'Utilisateur ajouté avec succès',
      editUserSuccess: 'Utilisateur édité avec succès',
      deleteUserSuccess: 'Utilisateur supprimé avec succès',
      deleteModalAlertMessage:
        "Vous êtes sur le point de supprimer l'utilisateur {{userName}}. Toutes les permissions pour l'utilisateur seront révoquées.",
      deleteProceedMessage: 'Voulez-vous procéder à la suppression?',
      userAlreadyExist:
        "Un utilisateur existe déjà avec cet identifiant d'e-mail.",
      addUserError: "Impossible d'ajouter l'utilisateur. Veuillez réessayer.",
      editUserError: "Impossible d'éditer l'utilisateur. Veuillez réessayer.",
      deleteUserError:
        "Impossible de supprimer l'utilisateur. Veuillez réessayer.",
      nodesError: "Erreur d'extraction des nœuds affectés",
      childNodesError: 'Erreur de chargement des nœuds enfants',
      hierarchyError: 'Erreur d’extraction de la hiérarchie',
      requestFailed: 'Échec de la requête',
      emailSentSuccess: "E-mail d'activation bien envoyé !",
      activationEmailError: "Échec de l'envoi de l'e-mail d'activation.",
      activationEmailError1:
        'Échec de l’envoi du courriel d’activation. Veuillez essayer à nouveau plus tard.',
      allOrganisations: 'Toutes les organisations',
      address: 'Adresse',
      hierarchyMetaError: 'Erreur d’extraction des détails de la hiérarchie',
      nodeMetaError: 'Erreur de chargement des détails du nœud',
      contactName: 'Prénom Contact',
      downloadTemplate: 'Télécharger le modèle',
      newOrg: 'Nouvelle organisation',
      save: 'enregistrer',
      upload: 'charger',
      uploading: 'Sauvegarde',
      dropExcel: 'Déposer la feuille Excel ou',
      browse: 'parcourir',
      importSettings: 'Importer les paramètres',
      addNodesSites: 'Ajouter de nouveaux nœuds/sites',
      updateNodesSites:
        'Mettre à jour les informations sur les nœuds/sites existants',
      disableNodesSites: 'Désactiver les nœuds/sites qui n’existent plus',
      disabled: 'Désactivé',
      new: 'Nouveau',
      updated: 'Mis à jour',
      siteInstallation: 'Sites',
      addOrgSuccess: 'Organisation créée avec succès !',
      excelUploadError: "Échec de l'enregistrement Excel. Veuillez réessayer.",
      saveError:
        'Échec de l’enregistrement. Veuillez réessayer ultérieurement.',
      saveBadRequestError:
        "Échec de l'enregistrement. Il s'agit probablement d'un problème avec les données que vous tentiez de sauvegarder.",
      telephone: 'téléphone',
      externalIds: 'identifiants externes',
      contactEmail: 'E-mail de contact',
      longitude: 'Longitude',
      latitude: 'Latitude',
      primaryContactName: 'nom du contact principal',
      primaryContactEmail: 'E-mail de contact principal',
      templateError:
        'Erreur lors du téléchargement du modèle. Veuillez réessayer ultérieurement',
      templateError1:
        "Impossible d'obtenir le modèle. Veuillez réessayer ultérieurement",
      home: 'Accueil',
      organisations: 'Organisations',
      users: 'Utilisateurs',
      lightTheme: 'Thème lumineux',
      darkTheme: 'Thème sombre',
      login: 'Connexion',
      logout: 'Déconnexion',
      activateUserAcc: 'Activer le compte utilisateur',
      phoneNumber: 'Numéro de téléphone',
      optional: 'optionnel',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      endUser: "Contrat de licence d'utilisateur final",
      iAccept: "J'accepte le Contrat de licence d'utilisateur final",
      iHereby: 'Je confirme par la présente avoir lu et accepté la',
      eula: 'CLUF',
      iRead: 'J’ai lu la Politique de confidentialité de Honeywell',
      iUnderstood: 'Oui, j’ai lu et je comprends la',
      privacyPolicy: 'Politique de confidentialité',
      activate: 'activer',
      activationSuccess: 'Activation réussie',
      newAccAccess:
        'Afin d’accéder à votre nouveau compte, connectez-vous avec votre nouveau nom d’utilisateur. Ce nouveau nom d’utilisateur est affiché ci-dessous:',
      emailSent:
        "Le nouveau nom d’utilisateur a été envoyé à votre identifiant d'e-mail.",
      signin: 'CONNEXION',
      activationError: 'Activation échoué',
      pleaseTryAgain: 'Veuillez réessayer',
      activationExpired: 'Le jeton d’activation a expiré',
      activationExpiredText:
        "Cela peut être dû au fait que le lien de l'e-mail a expiré, a déjà été utilisé ou était incorrect. Si le problème persiste, veuillez demander un nouvel e-mail d'activation.",
      contactSupport: 'Erreur. Veuillez contacter le support',
      pwdMatch: 'Les mots de passe doivent correspondre',
      required: 'Requis',
      eligiblePwd:
        'Le mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre, un caractère spécial et 11 caractères au minimum',
      invalidPhoneNumber: 'Numéro de téléphone non valide',
      invalidName:
        'Le nom ne doit pas dépasser 255 caractères sans espaces au début ou à la fin',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'fuseau horaire',
      timeZone: 'fuseau horaire',
      commissioningStatus: 'statut de la mise en service',
      countryCode: 'code pays',
      childCount: 'nombre d’enfants',
      sheetVersion: 'Version de la feuille',
      unknownError: 'Erreur inconnue. Veuillez réessayer ultérieurement.',
      preview: 'aperçu',
      file: 'Fichier',
      inCompatibleExcel: 'Le fichier doit être au format .xlsx.',
      selectOrg: 'Sélectionner l’organisation',
      noRecordFound: 'Enregistrement introuvable',
      total: 'Total',
      items: 'Éléments',
      forbidden: 'Interdit',
      noPermissionText: "Vous n'avez pas l'autorisation d'accéder à cette page",
      accessPermission:
        "Veuillez vous connecter à un compte disposant d'autorisations d’accès",
      technicianExternalAccessPermission:
        'Veuillez vous connecter à l’application mobile',
      redirectToLogin: 'Redirection vers la page de connexion',
      errorUserSettings: "Erreur d'extraction des paramètres de l'utilisateur",
      invalidSystemGuid: 'GUID système invalide',
      languageNotSupported: 'Langue non prise en charge',
      subscriptions: 'Abonnements',
      gatewayManagement: 'Gestion de la passerelle',
      subscriptionNumber: 'Numéro d’abonnement',
      orderNumber: 'Numéro de commande',
      bundle: 'Paquet',
      activatedOn: "Date d'activation",
      order: 'ordre',
      editSubscription: "Modifier l'abonnement",
      noNodeSelected: 'Aucun nœud sélectionné',
      noUserSelected: 'Aucun utilisateur sélectionné',
      loadingBundles: 'Chargement des lots...',
      bundlesError: 'Erreur lors de la récupération des groupes',
      selectBundle: 'Sélectionnez le bundle',
      addSubscriptionSuccess: 'Abonnement ajouté avec succès',
      addSubscriptionError:
        "Impossible d'ajouter l'abonnement. Veuillez réessayer.",
      subscriptionInputValidationError:
        "peut être une valeur alphanumérique avec un trait d'union et ne doit pas dépasser 13 caractères",
      errorUserGlobalPrivileges:
        "Erreur lors de la récupération des privilèges globaux de l'utilisateur",
      subscriptionAlreadyExist: "L'abonnement existe déjà.",
      invalidSubscription: 'Abonnement invalide',
      Version: 'Version',
      systemType: 'Type de système',
      systemId: 'ID système',
      reviewGatewayDetails: 'Examiner les détails de la passerelle',
      site: 'Site',
      Organisation: 'Organisation',
      gatewayRegistration: 'Enregistrement de la passerelle',
      selectAnOrg: 'Sélectionnez une organisation',
      selectASite: 'Sélectionnez un site',
      register: 'Enregistrer',
      selectSiteToRegsiter:
        'Sélectionnez le site pour enregistrer la passerelle',
      gatewayRegistrationFailureMsg:
        "Échec de l'enregistrement de la passerelle avec la plate-forme Honeywell Sentience IOT",
      gatewayRegistrationSuccessMsg:
        'Gateway a été enregistré avec succès auprès de la plate-forme Honeywell Sentience IOT',
      siteEmptyMsg:
        "Tous les sites de l'organisation {{- orgName}} sont déjà enregistrés",
      forgeOnboarding: 'Mappage org',
      SiteFetchingFailure: 'Echec de la récupération des sites depuis Forge',
      selectAllSitesText:
        'Sélectionner tous les faux sites à intégrer dans le Remote Building Manager',
      onBoardingFailure: 'Échec d’initiation de l’intégration du site',
      customerID: 'ID Client',
      enterCustomerID: 'Entrez l’ID client',
      loadingSites: 'Chargement de sites...',
      fetchSites: 'EXTRACTION DE SITES',
      subscriptionActivateSuccess:
        'Abonnement pour "{{siteName}}" activé avec succès',
      subscriptionActivateError:
        "Impossible d'activer en raison d'un problème technique, veuillez contacter votre administrateur",
      activateNow: 'Activer maintenant',
      multiSiteSuccess: 'Les sites ont été ajoutés avec succès.',
      onboardSelected: 'Intégrer sélectionné',
      sitePartialSuccess:
        'Certains sites n’ont pas été intégrés à cause de problèmes techniques. Veuillez réessayer ou contactez votre administrateur.',
      confirm: 'Confirmer',
      onboardingFailed: 'Échec de l’intégration',
      failed: 'Échec',
      onboardedSuccessfully: 'Site intégré',
      notOnboarded: 'Non intégré',
      onboarding: 'Intégration en cours...',
      reOnboard: 'Intégrer à nouveau',
      selectAll: 'Sélectionner tout',
      siteSuccess: 'Site ajouté avec succès.',
      dataloseWarning:
        "Veuillez ne pas actualiser la page pendant l'intégration des sites.",
      addServiceSuccess: 'Services ajoutés avec succès',
      addServicesText: 'Ajouter des services',
      validityText: 'Période de validité',
      invalidInputError: 'entrée invalide',
      subsactivateError: 'Abonnement déjà activé',
      subsnotfoundError: "Détails de l'abonnement introuvables",
      invalidorderError: 'Numéro de commande invalide',
      bundnotfoundError: 'Détails du lot introuvables',
      subscribedServices: 'SERVICES SOUSCRIT',
      subsactivateSuccess: 'Abonnement créé et activé avec succès',
      subsactivateFailure:
        "L'abonnement a été créé, mais l'activation a échoué. Veuillez réessayer !!",
      subsactivateDiffSite: 'Abonnement déjà activé pour un autre site',
      gatewayAssociation: 'Association de passerelle',
      systemGuid: 'GUID système',
      success: 'Succès',
      contactSystemAdministrator: 'Contactez votre administrateur système',
      siteName: 'Nom du site',
      location: 'Emplacement',
      action: 'Action',
      addNewSite: 'Ajouter un nouveau site',
      add: 'Ajouter',
      sitesAssociated: '{{siteCount}} Sites associés',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Rechercher les sites',
      noResultFound: 'Aucun résultat',
      noDataFound: 'Aucune donnée trouvée',
      loadMore: 'Charger plus',
      unlinkMessage:
        'Pour dissocier {{siteName}} de {{sku}}, veuillez contacter le service client Honeywell (+01 480-353-3020) ou envoyer un e-mail à support@honeywell.com',
      associatedOrderNumber: 'Numéro de commande associé',
      associatedSubscriptionNumber: "Numéro d'abonnement associé",
      helperTextSKU:
        'Pour modifier le numéro de l’abonnement, veuillez contacter',
      helperOrderTextSKU:
        'Pour modifier le numéro de commande, veuillez contacter',
      customerCare: 'Service client',
      skuDetails: "Détails de l'UGS",
      manageSites: 'Gérer les sites',
      skuName: "Nom de l'UGS",
      skuDescription: "Description de l'UGS",
      licenseUtilization: 'Utilisation des licences',
      validTill: "Valable jusqu'au",
      editSKU: 'Modifier le SKU',
      duplicateSiteError: 'Le site est déjà ajouté',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: 'Erreur lors de la récupération de la liste des sites',
      siteSuccessMsg: 'Ajoutés avec succès',
      siteFailedMsg: "Échec de l'ajout de",
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'Nouvel abonnement ajouté',
      licensesOf: 'Licences de',
      all: 'Tous',
      orderPlacedBy: 'Commande passée par',
      pendingRenewal: 'En attente de renouvellement',
      daysRemaining: 'Jours restant',
      renewSubscriptionMessage:
        'Pour renouveler {{skuName}}, veuillez contacter le service client Honeywell (+01 480-353-3020) ou envoyer un e-mail à support@honeywell.com',
      columnSelection: 'Sélection de colonne',
      selectUpTo: "Vous pouvez sélectionner jusqu'à",
      itemsToDisplay: 'éléments à afficher dans le tableau.',
      subscriptionManagement: 'Gestion des abonnements',
      activated: 'Activé',
      warningHeader: 'Voulez-vous vraiment annuler ?',
      warningMessage: 'Des modifications non enregistrées seront perdues',
      renewSubscription: "Renouveler l'abonnement",
      pendingActivation: 'Activation en attente',
      notAuthorizedError:
        "Vous n'êtes pas autorisé à affecter SKU à cette organisation",
      gatewayRegistrationInProgress: '{{gateway}} en cours',
      gatewayAssociationFailed:
        'Veuillez vérifier la connectivité de la passerelle et réessayer, en cas de nouvel échec, veuillez',
      gatewayRegistrationFailed:
        'Veuillez réessayer. en cas de nouvel échec, veuillez',
      doAssociationMessage:
        'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: "Erreur dans le traitement de l'association.",
      association: 'Association',
      dataloseWarningForRegistration:
        "L'enregistrement de la passerelle est en cours, cela peut prendre quelques minutes. Veuillez ne pas actualiser pour éviter la perte de données.",
      dataloseWarningForAssociation:
        'Association de passerelle est en cours, cela peut prendre quelques minutes. Veuillez ne pas actualiser pour éviter la perte de données.',
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Unité',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Modèle ajouté avec succès',
      addTemplateError: "Impossible d'ajouter un modèle.Veuillez réessayer.",
      updateTemplateSuccess: 'Template mise à jour avec succès',
      updateTemplateError:
        'Impossible de mettre à jour le modèle.Veuillez réessayer.',
      outOfRangeError: 'La valeur doit être entre {{min}} et {{max}}',
      requiredField: 'Veuillez remplir tous les champs (s)',
      templateName: 'Nom de modèle',
      modelName: 'Nom du modèle',
      vendorName: 'Nom du fournisseur',
      uniqueValueError: 'La valeur doit être unique',
      templateMangement: 'Gestion des modèles',
      equipmentType: "Type d'équipement",
      selectType: 'Sélectionner le type',
      listOfTemplate: 'Liste de modèles',
      selectTemplate: 'Sélectionner le modèle',
      ElectricityVoltage: "Tension d'électricité",
      ElectricityCurrent: 'Courant électrique',
      ElectricPowerFactor: 'Facteur de puissance électrique',
      ElectricFrequency: 'Fréquence électrique',
      EnergyReceived: 'Énergie reçue',
      ActivePower: 'Puissance active',
      ActivePowerA: 'Puissance active a',
      ActivePowerB: 'Puissance active b',
      ActivePowerC: 'Puissance active c',
      ReactivePower: 'Puissance réactive',
      ApparentPower: 'Puissance apparente',
      PeakDemand: 'Demande de pointe',
      ElectricityCurrentA: "Courant d'électricité A",
      ElectricityCurrentB: "Courant d'électricité b",
      ElectricityCurrentC: "Courant d'électricité C",
      ElectricityVoltageA: "Tension d'électricité A",
      ElectricityVoltageB: "Tension d'électricité B",
      ElectricityVoltageC: "Tension d'électricité C",
      ElectricityConsumption: "La consommation d'électricité",
      loaderWelcomeMessage:
        "Bienvenue sur le portail d'intégration. Veuillez patienter.",
      latitudeAndLongitude: 'Latitude & Longitude',
      siteUpdateSuccessMessage:
        'Les détails du site ont été mis à jour avec succès',
      siteUpdateErrorMessage:
        'Erreur lors de la mise à jour des détails du site',
      provisioningFailedMessages:
        'Échec de la mise en service du site. Veuillez réessayer',
      onboardAllSites: 'Intégrer tous les sites',
      geoCordinatesErrorMsg: 'Veuillez vérifier les coordonnées',
      tooltipCordinateMessage: 'les coordonnées doivent être entre',
      emptyValueMessage: 'Valeur vide interdite',

      browseFile: 'Browse File',
      fileTypeErrorMsg: 'File type is not allowed',

      orgImgTitle: 'Upload Organization Logo',
      orgImgDropTxt: 'Drag and Drop Logo',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px and Only *.png file format',
      orgImgPreviewTxt: 'Preview Logo',
      orgImgTooltipTxt:
        'Logo to have transparent background and should contrast black header background',
      orgImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb',

      siteImgTitle: 'Upload Site image',
      siteImgDropTxt: 'Drag and Drop Building image (*.png or .jpg)',
      siteImgPreviewTxt: 'Preview Site Details Page',
      siteTooltipTxt:
        'Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px and *.png & *.jpg file format',
      siteImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb',
      orTxt: 'Or',
      addLogo: 'Add Logo',
      addImage: 'Add Image',
      imageUploadSuccess: 'Image Uploaded Successfully',
      alertnteId: "Nom d'utilisateur alternatif:",
      username: "nom d'utilisateur:",
      errorFetchingUser:
        "Erreur lors de la récupération des détails de l'utilisateur",
      errorFetchingRoles: 'Erreur lors de la récupération des rôles',

      gateway: 'PASSERELLE',
      associateAndSyncBtn: 'ASSOCIER & SYNCHRONISER',
      cancelBtn: 'ANNULER',
      guidValidationError: 'Erreur de validation du GUID',
      gatewayId: 'ID DE PASSERELLE',
      addNewGateway: 'Ajouter une nouvelle passerelle',
      successMessage1: 'Association du site, terminée',
      successMessage2:
        'Association du site, terminée. La synchronisation du modèle sera lancée',
      errorMessage:
        'Association échouée, la synchronisation du modèle ne sera pas lancée',
      importUsers: 'Importer des utilisateurs',
      importUsersSubHeading:
        'Ajoutez et gérez ce que vous souhaitez importer en téléchargeant le modèle CSV.',
      dropCsvHere: 'Glissez et déposez le fichier ici ou',
      browsrForFiles: 'Parcourir les fichiers',
      subHeadingBrowser:
        'Seuls les fichiers CSV sont acceptés et le fichier ne doit pas dépasser 5 Mo.',
      subHeadingBrowserTwo: '(un seul téléchargement possible à la fois)',
      userUploadSuccess: 'Successfully data sent',
      userUploadProcessing:
        'The data has been successfully uploaded. We are currently processing and will take a few minutes. We will update you soon.',
      fileNameDisplay: 'File Name :',
      fileName: 'File Name',
      errorNotification:
        'We encountered an issue while uploading the template, please rectify below errors and re-upload the template.',
      errorHeading: 'Erreur',
      slnumber: 'SL NO.',
      errorMessageHeading: 'ERROR MESSAGE',
      endUserAgreement: 'Conditions générales de Honeywell Forge',
      privacyStatement: 'Déclaration de confidentialité',
      yourPrivacyChoices: 'Vos choix en matière de confidentialité',
      cookieNotice: 'Avis sur les cookies',
      dataCentre: 'Centre de données',
      isForgeText: 'Bâtiments',
      gatewayIdleMessage:
        'Vous avez été inactif pendant quelques minutes, veuillez actualiser la page pour continuer',
      refresh: 'Actualiser',
      landingLogin: 'Cliquez ici',
      loginUserIntegratorRole: 'Utilisateurs BA e-commerce',
      loginUserCustomerRole: 'Tous les autres utilisateurs',
      loginWelcomeNote:
        'Bienvenue, veuillez choisir votre rôle ci-dessous pour commencer.',
      termsAndConditions: 'Conditions générales',
      accept: 'Accepter',
      legalPatentInformation: 'Informations légales sur les brevets',
      onboardingPortal: "Portail d'intégration",
      customers: 'Clients',
      templates: 'Modèles',
      assetModelling: 'Modélisation des biens',
      selectCustomer: 'Sélectionner le client',
      integration: 'Intégration',
      integrationSubtitle:
        'Intégration transparente pour des analyses de performance en temps réel',
      customer: 'Client',
      accessibleCustomersError:
        'Erreur lors de la récupération des clients accessibles',
      workflows: 'Flux de travail (existants)',
      apiCredentials: 'Identifiants API',
      integrationsTab: 'Flux de travail',
      noSubscription:
        'Aucun abonnement actif trouvé. Veuillez vous abonner pour accéder à cette fonctionnalité.',
      loading: 'Chargement...',
      licenseManagement: 'Gestion des licences',
      activityLogTitle: 'Journaux d’activité',
      activityLogSubtitle:
        'Suivre les événements de workflow et les mises à jour de statut pour les clients sélectionnés',
      activityLogSidebarTitle: 'Journaux d’activité',
      activityLogSidebarSubtitle:
        'Voici les données d’activité pour l’ensemble de vos organisations clientes',
      activityLogListTitle: 'Liste des activités',
      activityLogSearchPlaceholder: 'Recherche par activité, site',
      activityLogLastUpdated: 'Dernière mise à jour',
      activityLogCreatedOn: 'Créé le',
      activityLogActivity: 'Activité',
      activityLogSite: 'Site',
      activityLogStatus: 'État',
      activityLogCreatedBy: 'Créé par',
      activityLogUpdatedBy: 'Mis à jour par',
      activityLogNameUnavailable: 'Nom non disponible',
      activityLogUserNamesError:
        'Échec du chargement des noms des créateurs/modificateurs',
      activityLogStatusSuccess: 'Succès',
      activityLogStatusFailed: 'Échec',
      activityLogStatusInProgress: 'En cours',
      activityLogStatusQueued: 'En attente',
      activityLogStatusPending: 'En attente',
      activityLogStatusSkipped: 'Ignoré',
      activityLogPaginationInfo:
        '{startItem} - {endItem} sur {totalItems} éléments',
      activityLogPageGoTo: 'Aller à la page',
      activityLogRowPerPage: 'Lignes par page',
      activityLogRetry: 'Réessayer',
      activityLogRetrying: 'Réessai ...',
      activityLogRetrySuccess: 'Réessai de tâche lancé avec succès.',
      activityLogRetryError:
        'Impossible de relancer la tâche. Veuillez réessayer.',
      activityLogRetryAllSuccess:
        'Toutes les tâches ont été réessayées avec succès.',
      activityLogRetryAllFailed:
        'Toutes les tentatives de réessai ont échoué. Veuillez réessayer.',
      activityLogRetryPartialFailed:
        'Échec de la relance de certaines tâches. Veuillez réessayer.',
      activityLogLoading: 'Chargement des détails...',
      activityLogFetchError:
        "Échec du chargement des données d'activité. Veuillez réessayer.",
      activityLogModalClose: 'Fermer',
      activityLogModalTasks: 'Tâches',
      activityLogModalCreatedOn: 'Créé le',
      activityLogModalLastUpdatedOn: 'Dernière mise à jour le',
      activityLogModalSupportNote:
        "Description de l'événement d'échec et du code de motif.",
      activityLogModalSupportReach: 'Pour toute assistance, contactez',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filtrer par',
      noCustomersAvailable: 'Aucun client disponible',
      activityLogFilterStatus: 'État',
      activityLogFilterActivity: 'Activité',
      activityLogFilterSite: 'Site',
      activityLogFilterCreatedBy: 'Créé par',
      activityLogFilterApply: 'Appliquer',
      activityLogFilterReset: 'Réinit.',
      activityLogFilterNoOptions: 'Aucune option disponible',
      activityLogFilterError:
        'Impossible de charger les options de filtre. Veuillez réessayer.',
      search: 'Rechercher',
      more: 'plus',
      noResults: 'Aucun résultat',
      activityLogCustomizeColumns: 'Personnaliser les colonnes',
      activityLogColumnsReorder: 'Réordonner',
      activityLogColumnsAddRemove: 'Ajouter/Supprimer',
      activityLogColumnsReorderDescription:
        "Repositionnez pour modifier l'ordre des colonnes dans le tableau",
      activityLogColumnsAddRemoveDescription:
        'Cochez les colonnes pour les afficher dans le tableau',
      activityLogDetails: 'Détails',
      activityLogFiltersChanged:
        'Aucune donnée trouvée pour les filtres sélectionnés. Veuillez ajuster ou réinitialiser vos filtres pour afficher les résultats.',
      activityLogResetFilters: 'Réinitialiser les filtres',
      activityLogSiteState: 'État',
      activityLogSiteCity: 'Ville',
      workflowTaskCBCustomerCreation: 'Création de client CB',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        "Mise à jour de l'état de l'intégration dans le portail partenaire",
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'Mise à jour de l’identifiant client CB dans le portail partenaire',
      workflowTaskEOMCustomerCreation: "Création d'une clientèle EOM",
      workflowTaskOnboardCustomerForAI: "Intégrer le client pour l'IA",
      workflowTaskDeleteCustomerInCBPortal:
        'Supprimer le client dans le portail CB',
      workflowTaskUpdateCustomerInCBPortal:
        'Mettre à jour le client dans le portail CB',
      workflowTaskUpdateCustomerInEOM: 'Mettre à jour le client dans EOM',
      workflowTaskUpdateCustomerInAssetModelling:
        'Mettre à jour le client dans la modélisation des actifs.',
      workflowTaskTrackScanStatusFileAttachment:
        "Suivre l'état d'analyse de la pièce jointe",
      workflowTaskCBSiteCreation: 'Création de site CB',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        "Mettre à jour l'ID du site CB dans le portail partenaire",
      workflowTaskEOMSiteCreation: 'Création de site EOM',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        "Mettre à jour l'ID du site EOM dans le portail partenaire",
      workflowTaskSyncExistingUsersCBPortal:
        'Synchroniser les utilisateurs existants vers CB Portal',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        "Mettre à jour l'état de synchronisation de l'utilisateur dans le portail partenaire",
      workflowTaskCalculateEnergySavingsPotential:
        'Calculer le potentiel d’économie d’énergie',
      workflowTaskDeleteSiteInCBPortal: 'Supprimer le site dans le portail CB',
      workflowTaskDeleteSiteInEOM: 'Supprimer le site dans EOM',
      workflowTaskUpdateSiteInCBPortal:
        'Mise à jour du site dans le portail CB',
      workflowTaskUpdateSiteInEOM: 'Mise à jour du site dans EOM',
      workflowTaskUpdateSiteInAssetModelling:
        'Mettre à jour le site dans la modélisation des actifs',
      workflowTaskUpdateSiteInFindAPI: 'Mettre le site à jour dans Find API',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Synchronisation de l’association d’abonnement avec le portail CB',
      workflowTaskEnableBrickOntology: 'Activer l’ontologie Brick',
      workflowTaskOnboardCustomerForgeAPI: 'Intégrer le client à ForgeAPI',
      workflowTaskPublishForgeAPIOnboardingStatus:
        "Publier l'état de l'intégration ForgeAPI dans la gestion des identifiants",
      workflowTaskAddUserInCBPortal:
        'Ajouter un utilisateur dans le portail CB',
      workflowTaskUpdateUserProvisioningStatus:
        "Mettre à jour l'état de mise en service de l'utilisateur",
      workflowTaskDeleteUserInCBPortal:
        'Supprimer l’utilisateur dans le portail CB',
      workflowTaskUpdateUserDeletionStatus:
        "Mise à jour de l'état de suppression d'utilisateur",
      workflowCustomerCreation: 'Création de client',
      workflowCustomerDelete: 'Suppression de client',
      workflowCustomerUpdate: 'Mise à jour de client',
      workflowFileAttachmentsScan: 'État de numérisation des pièces jointes',
      workflowSiteCreation: 'Création de site',
      workflowSiteDelete: 'Suppression de site',
      workflowSiteUpdate: 'Mise à jour de site',
      workflowSubscriptionAssociation: "Association d'abonnement",
      workflowAddUser: 'Ajouter un utilisateur',
      workflowDeleteUser: "Suppression d'utilisateur",
      workflowNamePlate: 'Plaque Signalétique',
      workflowForgeAPIOnboarding: "Intégration de l'API Forge",
      workflowAddUserMultiple:
        'Flux de travail pour ajouter un utilisateur (multiple)',
      workflowDeleteUserMultiple:
        'Flux de travail pour supprimer un utilisateur (multiple)',
      workflowModelFileUpload: 'Téléversement du fichier de modèle',
      workflowGatewayAssociation: 'Association de passerelle',
      workflowIntegrationRegistered: 'Intégration enregistrée',
      workflowTaskForgeAPIOnboardingStatus:
        "État de l'intégration de l'API Forge",
      workflowTaskAddUser: 'Flux de travail pour ajouter un utilisateur',
      workflowTaskProcessModelFile: 'Fichier de modèle de processus',
      workflowTaskNotifyAssetModelling:
        'Notifier la modélisation des ressources',
      workflowTaskAssociateGateway: 'Associer une passerelle à un site',
      workflowTaskFetchModelToAssetModelling:
        'Récupérer le modèle pour la modélisation d’actif',
      workflowTaskNameProcessNamePlate: 'Traitement du fichier Nameplate',
      workflowTaskUpdateModelInFindAPI: 'Mettre le modèle à jour dans Find API',
      workflowTaskProcessIntegrationRegistered:
        'Intégration de processus enregistrée',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'Traiter la notification DF pour l’intégration enregistrée',
      workflowTaskTenantOnboardingAFO: 'Intégration du locataire à AFO',
      workflowTaskOnboardCustomerCDL: 'Intégrer le client pour CDL',
      workflowTaskPublishAFOOnboardingStatus: 'Publier le statut d’intégration à AFO dans le service Rule Builder',
      activityLogCorrelationId: 'Identifiant de corrélation',
      activityLogTaskId: 'Identifiant de tâche',
      activityLogToastSuccess: 'Succès',
      activityLogToastError: 'Erreur',
      activityLogIteration: 'Itération',
      activityLogFieldFirstName: 'Prénom',
      activityLogFieldLastName: 'Nom',
      activityLogFieldSubscriptionName: 'Nom de l’abonnement',
      activityLogFieldName: 'Nom',
      activityLogFieldCurrency: 'Monnaie',
      activityLogFieldZip: 'Code postal',
      activityLogFieldArea: 'Zone',
      activityLogFieldCity: 'Ville',
      activityLogFieldState: 'État',
      activityLogFieldCountry: 'Pays',
      activityLogFieldAreaUnit: 'Unité de zone',
      activityLogFieldLanguage: 'Langue',
      activityLogFieldLatitude: 'Latitude',
      activityLogFieldSiteType: 'Type de site',
      activityLogFieldTimezone: 'Fuseau horaire',
      activityLogFieldLongitude: 'Longitude',
      activityLogFieldCountryCode: 'Code pays',
      activityLogFieldSiteId: 'ID site',
      activityLogFieldFileType: 'Type de fichier',
      activityLogFieldReason: 'Motif',
      activityLogFieldCustomerSupportEmails: 'Adresses e-mail du support client',
      activityLogFieldAddressLine1: "Ligne d'adresse 1",
      activityLogFieldAddressLine2: "Ligne d'adresse 2",
      activityLogFieldContactEmail: 'E-mail de contact',
      activityLogSiTitle: "Journal d'activité",
      support: 'Support',
      projectManagement: 'Gestion de projets',
    }
  }
};
